package com.schoolconnect.app.feature.homework

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.ButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import androidx.compose.ui.unit.dp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListViewActionButton
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.attendance.ParentAttendanceChild
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.book
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.user
import org.jetbrains.compose.resources.painterResource

@Composable
fun ParentHomeworkScreen(
    state: ParentHomeworkUiState,
    onEvent: (ParentHomeworkUiEvent) -> Unit,
    shellRoleCode: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit
) {
    var profileExpanded by remember { mutableStateOf(false) }
    var rowsPerPageExpanded by remember { mutableStateOf(false) }
    val window = pageWindow(state.pageIndex, state.pageSize, state.totalCount)
    AdminListPageScaffold(
        title = "Homework", subtitle = "View homework and assignments for your child.", backgroundColor = AppBackground, titleColor = AppPageHeader, subtitleColor = AppPageSubtitle,
        headerActions = { ShellTopRightActions(shellRoleLabel(shellRoleCode), shellRoleSubtitle(shellRoleCode), shellAvatarInitials(shellRoleLabel(shellRoleCode)), profileExpanded, { profileExpanded = it }, onChangeRole, onLogout) },
        summaryCards = { ParentHomeworkMetric("Open", state.open.toString(), "Assignments", Res.drawable.book, AppSuccess, AppSuccessSoft); ParentHomeworkMetric("Due Soon", state.dueSoon.toString(), "Assignments", Res.drawable.book, AppWarning, Color(0xFFFFF2D9)); ParentHomeworkMetric("Due Today", state.dueToday.toString(), "Assignments", Res.drawable.ban, AppDanger, AppDangerSoft); ParentHomeworkMetric("Closed", state.closed.toString(), "Assignments", Res.drawable.circle_check, AppNavy, Color(0xFFF3F4F7)) },
        toolbar = { ParentHomeworkToolbar(state, onEvent) },
        table = { modifier ->
            AdminListTableCard(modifier = modifier, minContentWidth = 1120.dp,
                header = { AdminListSortHeaderRow(listOf(
                    AdminListSortColumn("Homework", 1.35f, state.sortField == ParentHomeworkSortField.HOMEWORK, state.sortAscending) { onEvent(ParentHomeworkUiEvent.SortChanged(ParentHomeworkSortField.HOMEWORK)) },
                    AdminListSortColumn("Class", .8f, state.sortField == ParentHomeworkSortField.CLASS, state.sortAscending) { onEvent(ParentHomeworkUiEvent.SortChanged(ParentHomeworkSortField.CLASS)) },
                    AdminListSortColumn("Subject", 1f, state.sortField == ParentHomeworkSortField.SUBJECT, state.sortAscending) { onEvent(ParentHomeworkUiEvent.SortChanged(ParentHomeworkSortField.SUBJECT)) },
                    AdminListSortColumn("Assigned By", 1.1f, state.sortField == ParentHomeworkSortField.ASSIGNED_BY, state.sortAscending) { onEvent(ParentHomeworkUiEvent.SortChanged(ParentHomeworkSortField.ASSIGNED_BY)) },
                    AdminListSortColumn("Assigned Date", 1f, state.sortField == ParentHomeworkSortField.ASSIGNED_DATE, state.sortAscending) { onEvent(ParentHomeworkUiEvent.SortChanged(ParentHomeworkSortField.ASSIGNED_DATE)) },
                    AdminListSortColumn("Due Date", 1f, state.sortField == ParentHomeworkSortField.DUE_DATE, state.sortAscending) { onEvent(ParentHomeworkUiEvent.SortChanged(ParentHomeworkSortField.DUE_DATE)) },
                    AdminListSortColumn("Status", .85f, state.sortField == ParentHomeworkSortField.STATUS, state.sortAscending) { onEvent(ParentHomeworkUiEvent.SortChanged(ParentHomeworkSortField.STATUS)) }
                ), actionsWeight = .55f) },
                body = {
                    val rows = state.rows
                    when {
                        state.isLoading -> AdminListTableShimmer(columns = listOf(AdminListHeaderColumn("Homework", 1.35f), AdminListHeaderColumn("Class", .8f), AdminListHeaderColumn("Subject", 1f), AdminListHeaderColumn("Assigned By", 1.1f), AdminListHeaderColumn("Assigned Date", 1f), AdminListHeaderColumn("Due Date", 1f), AdminListHeaderColumn("Status", .85f), AdminListHeaderColumn("Actions", .55f)), rowCount = state.pageSize)
                        state.errorMessage.isNotBlank() -> AppDialogErrorMessage(state.errorMessage)
                        rows.isEmpty() -> Text("No homework found", modifier = Modifier.fillMaxWidth().padding(40.dp), color = AppNavy, fontWeight = FontWeight.Bold)
                        else -> AdminListTableBody(items = rows, key = { it.backendId.ifBlank { it.homeworkId } }, modifier = Modifier.fillMaxWidth()) { row ->
                            Column(Modifier.fillMaxWidth()) {
                                Row(Modifier.fillMaxWidth().onViewDoubleClick { onEvent(ParentHomeworkUiEvent.ViewRequested(row)) }.heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
                                    AdminListTableBodyText(row.title, Modifier.weight(1.35f)); AdminListTableBodyText(row.className, Modifier.weight(.8f)); AdminListTableBodyText(row.subject, Modifier.weight(1f)); AdminListTableBodyText(row.assignedBy, Modifier.weight(1.1f)); AdminListTableBodyText(row.assignedDate, Modifier.weight(1f)); AdminListTableBodyText(row.dueDate, Modifier.weight(1f)); Box(Modifier.weight(.85f), contentAlignment = Alignment.CenterStart) { StatusChip(row.status) }
                                    Box(Modifier.weight(.55f), contentAlignment = Alignment.Center) { AdminListViewActionButton(onClick = { onEvent(ParentHomeworkUiEvent.ViewRequested(row)) }, contentDescription = "View homework") }
                                }
                                if (row != rows.last()) HorizontalDivider(color = AppBorder)
                            }
                        }
                    }
                }, footer = { AdminListFooter(pageText = pageFooterText(window, "assignments"), pageIndex = window.pageIndex, pageCount = window.pageCount, onPageChanged = { onEvent(ParentHomeworkUiEvent.PageChanged(it)) }, pageSize = state.pageSize, rowsPerPageExpanded = rowsPerPageExpanded, onRowsPerPageToggle = { rowsPerPageExpanded = !rowsPerPageExpanded }, onRowsPerPageDismiss = { rowsPerPageExpanded = false }, onPageSizeChanged = { onEvent(ParentHomeworkUiEvent.PageSizeChanged(it)) }) })
        }, bottomAction = { Spacer(Modifier.weight(1f)) }
    )
    ViewHomeworkDialog(
        homework = state.viewingHomework,
        attachmentMetadata = emptyMap(),
        isLoading = state.isViewingLoading,
        errorMessage = state.viewingError,
        showHomeworkId = false,
        onDismiss = { onEvent(ParentHomeworkUiEvent.ViewDismissed) }
    )
}

@Composable private fun RowScope.ParentHomeworkMetric(title: String, value: String, subtitle: String, icon: org.jetbrains.compose.resources.DrawableResource, accent: Color, bg: Color) = AdminListSummaryCard(title, value, subtitle, painterResource(icon), accent, bg, AppMuted, modifier = Modifier.weight(1f))


@Composable private fun ParentHomeworkToolbar(state: ParentHomeworkUiState, onEvent: (ParentHomeworkUiEvent) -> Unit) {
    AppCard(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        Row(Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 10.dp), verticalAlignment = Alignment.Bottom, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
            Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1.35f)) {
                Text("Search by Homework Title", color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 13.sp)
                AdminListSearchField(state.searchQuery, { onEvent(ParentHomeworkUiEvent.SearchChanged(it)) }, "Search...", width = 260.dp, height = 44.dp, modifier = Modifier.fillMaxWidth(), surfaceColor = Color.White, borderColor = AppBorder, textColor = AppNavy)
            }
            AppLabeledDropdownField(
                label = "Status",
                value = state.status,
                options = listOf("Open", "Due Soon", "Closed"),
                onSelected = { onEvent(ParentHomeworkUiEvent.StatusChanged(it)) },
                modifier = Modifier.weight(1.1f),
                allOptionLabel = "All"
            )
            AppOutlinedButton(
                onClick = { onEvent(ParentHomeworkUiEvent.FiltersReset) },
                modifier = Modifier.weight(.7f).height(44.dp),
                contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 12.dp),
                colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                shape = RoundedCornerShape(8.dp)
            ) {
                Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(17.dp), tint = AppPrimary)
                Spacer(Modifier.width(6.dp))
                Text("Clear", color = AppPrimary, maxLines = 1, softWrap = false)
            }
        }
    }
}

@Composable private fun StatusChip(value: String) {
    val color = when (value.trim().uppercase().replace(' ', '_')) {
        "OPEN" -> AppSuccess
        "DUE_SOON" -> AppWarning
        "OVERDUE" -> AppDanger
        "CLOSED" -> AppNavy
        else -> AppNavy
    }
    Text(
        value,
        Modifier,
        color = color,
        fontWeight = FontWeight.Medium,
        fontSize = 12.sp
    )
}
